const source = {
  "ui.sessionReview.title": "Session changes",
  "ui.sessionReview.title.git": "Git changes",
  "ui.sessionReview.title.branch": "Branch changes",
  "ui.sessionReview.title.lastTurn": "Last turn changes",
  "ui.sessionReview.diffStyle.unified": "Unified",
  "ui.sessionReview.diffStyle.split": "Split",
  "ui.sessionReview.expandAll": "Expand all",
  "ui.sessionReview.collapseAll": "Collapse all",
  "ui.sessionReview.change.added": "Added",
  "ui.sessionReview.change.removed": "Removed",
  "ui.sessionReview.change.modified": "Modified",
  "ui.sessionReview.image.loading": "Loading…",
  "ui.sessionReview.image.placeholder": "Image",
  "ui.sessionReview.largeDiff.title": "Diff too large to render",
  "ui.sessionReview.largeDiff.meta": "Limit: {{limit}} changed lines. Current: {{current}} changed lines.",
  "ui.sessionReview.largeDiff.renderAnyway": "Render anyway",
  "ui.sessionReviewV2.expandMode": "Expand or collapse diff",
  "ui.sessionReviewV2.filterFiles": "Filter files",
  "ui.sessionReviewV2.toggleSidebar": "Toggle file tree",
  "ui.sessionReviewV2.showAllLines": "Show all lines",
  "ui.sessionReviewV2.hideNonDiffLines": "Hide non-diff lines",
  "ui.sessionReviewV2.unifiedDiff": "Unified diff",
  "ui.sessionReviewV2.splitDiff": "Split diff",
  "ui.sessionReviewV2.previousFile": "Previous file",
  "ui.sessionReviewV2.nextFile": "Next file",
  "ui.sessionReviewV2.diffView": "Diff view",
  "ui.sessionReviewV2.empty.noGit.title": "No tracked changes",
  "ui.sessionReviewV2.empty.noGit.description": "Track, review, and undo changes in this project",
  "ui.sessionReviewV2.empty.noGit.action": "Create Git repository",
  "ui.sessionReviewV2.empty.noGit.actionLoading": "Creating Git repository…",
  "ui.sessionReviewV2.empty.changes.title": "No file changes yet",
  "ui.sessionReviewV2.empty.changes.description": "Project changes will appear here",

  "ui.sessionReview.openFile": "Open file",
  "ui.sessionReview.selection.line": "line {{line}}",
  "ui.sessionReview.selection.lines": "lines {{start}}-{{end}}",

  "ui.fileMedia.kind.image": "image",
  "ui.fileMedia.kind.audio": "audio",
  "ui.fileMedia.state.removed": "Removed {{kind}} file.",
  "ui.fileMedia.state.loading": "Loading {{kind}}…",
  "ui.fileMedia.state.error": "Unable to load {{kind}}.",
  "ui.fileMedia.state.unavailable": "{{kind}} preview unavailable.",
  "ui.fileMedia.binary.title": "Binary file",
  "ui.fileMedia.binary.description.path": "{{path}} is binary.",
  "ui.fileMedia.binary.description.default": "Binary content",

  "ui.lineComment.label.prefix": "Comment on ",
  "ui.lineComment.label.suffix": "",
  "ui.lineComment.editorLabel.prefix": "Commenting on ",
  "ui.lineComment.editorLabel.suffix": "",
  "ui.lineComment.placeholder": "Add comment",
  "ui.lineComment.contextPlaceholder": "Add context for this change",
  "ui.lineComment.submit": "Comment",
  "ui.lineComment.cancel": "Cancel",

  "ui.sessionTurn.steps.show": "Show steps",
  "ui.sessionTurn.steps.hide": "Hide steps",
  "ui.sessionTurn.summary.response": "Response",
  "ui.sessionTurn.diff.showMore": "Show more changes ({{count}})",
  "ui.sessionTurn.diffs.changed.one": "{{count}} Changed file",
  "ui.sessionTurn.diffs.changed.other": "{{count}} Changed files",
  "ui.sessionTurn.diffs.showAll": "Show all",
  "ui.sessionTurn.diffs.showLess": "Show less",
  "ui.sessionTurn.diffs.more": "+{{count}} more files",

  "ui.sessionTurn.retry.retrying": "retrying",
  "ui.sessionTurn.retry.inSeconds": "in {{seconds}}s",
  "ui.sessionTurn.retry.attempt": "attempt #{{attempt}}",
  "ui.sessionTurn.retry.attemptLine": "{{line}} - attempt #{{attempt}}",
  "ui.sessionTurn.retry.attemptLabel": "Attempt {{attempt}}",
  "ui.sessionTurn.retry.attemptRetrying": "Attempt {{attempt}} - {{line}}",
  "ui.sessionTurn.retry.attemptWaiting.one": "Attempt {{attempt}} - retrying in {{count}}s",
  "ui.sessionTurn.retry.attemptWaiting.other": "Attempt {{attempt}} - retrying in {{count}}s",
  "ui.sessionTurn.retry.attemptRetryingNow": "Attempt {{attempt}} - retrying",
  "ui.sessionTurn.retry.geminiHot": "gemini is way too hot right now",
  "ui.sessionTurn.error.freeUsageExceeded": "Free usage exceeded",
  "ui.sessionTurn.error.addCredits": "Add credits",

  "dialog.usageExceeded.freeTier.title": "Free limit reached",
  "dialog.usageExceeded.freeTier.description":
    "Subscribe to OpenCode Go for reliable access to the best open-source models for $10/month.",
  "dialog.usageExceeded.freeTier.actionLabel": "Subscribe",
  "dialog.usageExceeded.accountRateLimit.title": "Go limit reached",
  "dialog.usageExceeded.accountRateLimit.description":
    "Usage limit reached. To continue using this model now, enable usage from your available balance",
  "dialog.usageExceeded.accountRateLimit.actionLabel": "Open settings",

  "ui.sessionTurn.status.delegating": "Delegating work",
  "ui.sessionTurn.status.planning": "Planning next steps",
  "ui.sessionTurn.status.gatheringContext": "Exploring",
  "ui.sessionTurn.status.gatheredContext": "Explored",
  "ui.sessionTurn.status.searchingCodebase": "Searching the codebase",
  "ui.sessionTurn.status.searchingWeb": "Searching the web",
  "ui.sessionTurn.status.makingEdits": "Making edits",
  "ui.sessionTurn.status.runningCommands": "Running commands",
  "ui.sessionTurn.status.thinking": "Thinking",
  "ui.sessionTurn.status.thinkingWithTopic": "Thinking - {{topic}}",
  "ui.sessionTurn.status.gatheringThoughts": "Gathering thoughts",
  "ui.sessionTurn.status.consideringNextSteps": "Considering next steps",

  "ui.messagePart.diagnostic.error": "Error",
  "ui.messagePart.title.edit": "Edit",
  "ui.messagePart.title.write": "Write",
  "ui.messagePart.option.typeOwnAnswer": "Type your own answer",
  "ui.messagePart.review.title": "Review your answers",
  "ui.messagePart.questions.dismissed": "Questions dismissed",
  "ui.messagePart.compaction": "Session compacted",
  "ui.messagePart.compaction.started": "Session compaction started",
  "ui.messagePart.compaction.running": "Compacting",
  "ui.messagePart.compaction.failed": "Session compaction failed",
  "ui.messagePart.compaction.cancelled": "Session compaction cancelled",
  "ui.messagePart.compaction.interrupted": "Session compaction interrupted",
  "ui.messagePart.providerCompaction": "Session compacted by provider",
  "ui.messagePart.compaction.usage": "{{input}} in · {{output}} out",
  "ui.messagePart.context.updates": "Updates",
  "ui.messagePart.context.read.one": "{{count}} read",
  "ui.messagePart.context.read.other": "{{count}} reads",
  "ui.messagePart.context.search.one": "{{count}} search",
  "ui.messagePart.context.search.other": "{{count}} searches",
  "ui.messagePart.context.list.one": "{{count}} list",
  "ui.messagePart.context.list.other": "{{count}} lists",
  "ui.messagePart.context.notice.one": "{{count}} Notice",
  "ui.messagePart.context.notice.other": "{{count}} Notices",
  "ui.messagePart.context.thought.one": "Thought",
  "ui.messagePart.context.thought.other": "Thoughts",
  "ui.messagePart.context.match.one": "({{count}} match)",
  "ui.messagePart.context.match.other": "({{count}} matches)",
  "ui.messagePart.tools.used.one": "Used {{count}} {{tools}}",
  "ui.messagePart.tools.used.other": "Used {{count}} {{tools}}",

  "ui.list.loading": "Loading",
  "ui.list.empty": "No results",
  "ui.list.clearFilter": "Clear filter",
  "ui.list.emptyWithFilter.prefix": "No results for",
  "ui.list.emptyWithFilter.suffix": "",

  "ui.fileSearch.placeholder": "Find",
  "ui.fileSearch.previousMatch": "Previous match",
  "ui.fileSearch.nextMatch": "Next match",
  "ui.fileSearch.close": "Close search",

  "ui.messageNav.newMessage": "New message",

  "ui.promptInput.noMatchingItems": "No matching items",
  "ui.promptInput.commands": "Commands",
  "ui.promptInput.dropFiles": "Drop files to add",
  "ui.promptInput.dropFiles.image": "Drop images or files to add",
  "ui.promptInput.dropFiles.pdf": "Drop PDFs or files to add",
  "ui.promptInput.dropFiles.imagePdf": "Drop images, PDFs, or files to add",
  "ui.promptInput.removeAttachment": "Remove attachment",
  "ui.promptInput.cancelUpload": "Cancel upload",
  "ui.promptInput.uploading": "{{percent}}%",
  "ui.promptInput.label": "Prompt",
  "ui.promptInput.placeholder.shell": "Enter shell command…",
  "ui.promptInput.placeholder.normal": "Ask anything, {{slash}} for commands, {{at}} for context…",
  "ui.promptInput.placeholder.followUp": "Add follow-up, {{slash}} for commands, {{at}} for context…",
  "ui.promptInput.add": "Add images and files",
  "ui.promptInput.attachments": "Images and files",
  "ui.promptInput.context": "Context",
  "ui.promptInput.shell": "Shell command",
  "ui.promptInput.chooseAgent": "Choose agent",
  "ui.promptInput.chooseModel": "Choose model",
  "ui.promptInput.chooseVariant": "Choose model variant",
  "ui.promptInput.send": "Send",
  "ui.promptInput.stop": "Stop",
  "ui.promptInput.exitShell": "Exit",
  "ui.promptInput.steer": "Steer",
  "ui.promptInput.queue": "Queue",
  "ui.promptInput.steerHint": "Send without interrupting",

  "ui.tabs.close": "Close tab",

  "ui.textField.copyToClipboard": "Copy to clipboard",
  "ui.textField.copyLink": "Copy link",
  "ui.textField.copied": "Copied",

  "ui.imagePreview.alt": "Image preview",
  "ui.scrollView.ariaLabel": "scrollable content",

  "ui.tool.read": "Read",
  "ui.tool.loaded": "Loaded",
  "ui.tool.loadedFile": "Loaded {{path}}",
  "ui.tool.loadedSkill": "Loaded {{name}} skill",
  "ui.tool.loadedSkills.one": "Loaded {{name}} skill",
  "ui.tool.loadedSkills.other": "Loaded {{name}} skills",
  "ui.tool.list": "List",
  "ui.tool.glob": "Glob",
  "ui.tool.grep": "Grep",
  "ui.tool.task": "Task",
  "ui.tool.browser": "Browser",
  "ui.tool.webfetch": "Webfetch",
  "ui.tool.websearch": "Web Search",
  "ui.tool.websearch.provider": "{{provider}} Web Search",
  "ui.tool.shell": "Shell",
  "ui.tool.shell.writingCommand": "Writing command…",
  "ui.tool.shell.exit": "Command exited with code {{code}}",
  "ui.tool.shell.timeout": "Command timed out",
  "ui.tool.shell.cancelled": "Command cancelled",
  "ui.tool.execute": "Execute",
  "ui.tool.patch": "Patch",
  "ui.tool.questions": "Questions",
  "ui.tool.questions.numbered": "Questions {{number}}",
  "ui.tool.agent": "{{type}} Agent",
  "ui.tool.agent.default": "Agent",
  "ui.tool.agent.delegating": "Delegating agent…",
  "ui.tool.skill": "Skill",

  "ui.basicTool.called": "Called `{{tool}}`",
  "ui.toolErrorCard.failed": "Failed",
  "ui.toolErrorCard.copyError": "Copy error",

  "ui.common.file.one": "file",
  "ui.common.file.other": "files",
  "ui.common.fileCount.one": "{{count}} file",
  "ui.common.fileCount.other": "{{count}} files",
  "ui.common.question.one": "question",
  "ui.common.question.other": "questions",

  "ui.common.add": "Add",
  "ui.common.clear": "Clear",
  "ui.common.file": "File",
  "ui.common.back": "Back",
  "ui.common.cancel": "Cancel",
  "ui.common.confirm": "Confirm",
  "ui.common.dismiss": "Dismiss",
  "ui.common.close": "Close",
  "ui.common.next": "Next",
  "ui.common.submit": "Submit",
  "ui.common.showMore": "Show more",
  "ui.common.moreCount.one": "+{{count}} more",
  "ui.common.moreCount.other": "+{{count}} more",

  "ui.permission.deny": "Deny",
  "ui.permission.allowAlways": "Allow for this session",
  "ui.permission.allowOnce": "Allow once",

  "ui.message.expand": "Expand message",
  "ui.message.collapse": "Collapse message",
  "ui.message.copy": "Copy",
  "ui.message.copyMessage": "Copy message",
  "ui.message.forkMessage": "Fork to new session",
  "ui.message.revertMessage": "Revert message",
  "ui.message.copyResponse": "Copy response",
  "ui.message.copied": "Copied",
  "ui.message.thought": "Thought",
  "ui.message.duration.seconds": "{{count}}s",
  "ui.message.duration.minutesSeconds": "{{minutes}}m {{seconds}}s",
  "ui.message.interrupted": "Interrupted",
  "ui.sessionTimeline.notice.model": "Model",
  "ui.sessionTimeline.notice.modelSwitched": "Switched to {{model}}",
  "ui.sessionTimeline.notice.agentChanged": "Agent changed",
  "ui.sessionTimeline.notice.movedTo": "Moved to",
  "ui.sessionTimeline.notice.movedTooltip": "Session working directory changed",
  "ui.sessionTimeline.notice.failed": "{{actor}} failed",
  "ui.sessionTimeline.notice.cancelled": "{{actor}} cancelled",
  "ui.sessionTimeline.notice.finished": "{{actor}} finished",
  "ui.sessionTimeline.notice.instructionsUpdated": "Instructions updated",
  "ui.sessionTimeline.notice.restart": "Continuing after restart",
  "ui.message.queued": "Queued",
  "ui.message.attachment.alt": "attachment",

  "ui.patch.action.deleted": "Deleted",
  "ui.patch.action.created": "Created",
  "ui.patch.action.moved": "Moved",
  "ui.patch.action.patched": "Patched",

  "ui.question.subtitle.answered": "{{count}} answered",
  "ui.question.answer.none": "(no answer)",
  "ui.question.review.notAnswered": "(not answered)",
  "ui.question.multiHint": "Select all answers that apply",
  "ui.question.singleHint": "Select one answer",
  "ui.question.custom.placeholder": "Type your answer…",
} satisfies Record<string, string>

export type Key = keyof typeof source
export type PluralCategory = "zero" | "one" | "two" | "few" | "many" | "other"
export type PluralKey = {
  [Entry in Key]: Entry extends `${infer Base}.other` ? (`${Base}.one` extends Key ? Base : never) : never
}[Key]
export type PluralLookupKey = `${PluralKey}.${PluralCategory}`
export type LocaleKey = Key | PluralLookupKey
export const dict: typeof source & Record<string, string> = source
